<template>
  	<DataTable
		ref="dt"
		:loading="!transporterHeader"
		:value="header"
		:paginator="true"
		:rows="10"
		:rowClass="rowClass"
		responsiveLayout="scroll"
		class="editable-cells-table"
		filterDisplay="row"
		v-model:filters="filters"
	>
		<template #header>
		<div
			style="
			display: flex;
			justify-content: space-between;
			align-items: baseline;
			"
		>
			<h4>
			<span class="pi pi-exclamation-circle" style="font-size: 1.3rem" />
			Default Password : WILitm123!
			</h4>
			<Button label="Save" class="col-1 p-button-success" @click="saveData" :disabled="!canSave"/>
		</div>
		</template>
		<Column :exportable="false" :sortable="false">
		<template #filter>
			<Button
				label="Clear"
				icon="pi pi-trash"
				style="justify-content: center"
				class="p-button-outlined p-button-primary p-button-sm"
				:badge="filterBadge"
				badgeClass="p-badge-danger"
				@click="clearFilter"
			/>
		</template>
		<template #header>
			<Button
				icon="pi pi-plus"
				class="p-button-info p-button-sm"
				@click="addDetail()"
				:disabled="!canEdit"
			/>
		</template>
		<template #body="slotProps">
			<Button
				icon="pi pi-minus"
				class="p-button-danger p-button-sm mr-1"
				@click="deleteDetail(slotProps.data)"
				:disabled="!canEdit"
			/>
			<Button
				icon="pi pi-lock"
				class="p-button-primary p-button-sm"
				@click="changePass(slotProps.data)"
				v-if="slotProps.data.mode != $FORM_MODE_CREATE" 
				:disabled="!canEdit"
			/>
		</template>
		</Column>
    <Column field="User_Id" :header="$t('username')">
      <template #filter="{ filterModel, filterCallback }">
        <InputText
          type="text"
          :placeholder="$t('username')"
          v-if="filterModel"
          v-model="filterModel.value"
          @keydown.enter="filterCallback()"
          class="p-column-filter p-inputtext-sm"
        />
      </template>
      <template #body="slotProps">
        <InputText
          type="text"
          v-model="slotProps.data[slotProps.column.props.field]"
          class="p-inputtext-sm"
          :disabled="true"
          @change="editDetail(slotProps.data)"

        />
      </template>
    </Column>
    <Column field="Name" :header="$t('name')">
      <template #filter="{ filterModel, filterCallback }">
        <InputText
          type="text"
          :placeholder="$t('name')"
          v-if="filterModel"
          v-model="filterModel.value"
          @keydown.enter="filterCallback()"
          class="p-column-filter p-inputtext-sm"
        />
      </template>
      <template #body="slotProps">
        <InputText
          type="text"
          v-model="slotProps.data[slotProps.column.props.field]"
          class="p-inputtext-sm"
          @change="editDetail(slotProps.data)"
		  :disabled="!canEdit"
        />
      </template>
    </Column>
    <Column field="License_No" :header="$t('license_no')">
      <template #filter="{ filterModel, filterCallback }">
        <InputText
          type="text"
          :placeholder="$t('license_no')"
          v-if="filterModel"
          v-model="filterModel.value"
          @keydown.enter="filterCallback()"
          class="p-column-filter p-inputtext-sm"
        />
      </template>
      <template #body="slotProps">
        <InputText
          type="text"
          v-model="slotProps.data[slotProps.column.props.field]"
          class="p-inputtext-sm"
          @change="editDetail(slotProps.data)"
		  :disabled="!canEdit"
        />
      </template>
    </Column>
    <!-- <Column field="Password" :header="$t('password')">
      <template #body="slotProps">
        <Button
          type="button"
          label="Change"
          @click=""
          v-if="
            slotProps.data.mode && slotProps.data.mode != this.$FORM_MODE_CREATE
          "
        /> -->
        <!-- <span class="p-input-icon-right">
          <i
            :class="
              slotProps.data.showPassword == undefined
                ? 'pi pi-eye'
                : slotProps.data.showPassword
            "
            @click="passwordClass(slotProps.data)"
          />
          <InputText
            :type="
              slotProps.data.Password == 'pi pi-eye'
                ? 'pi pi-eye-slash'
                : 'pi pi-eye'
            "
            v-model="slotProps.data.Password"
            class="p-inputtext-sm"
          />
        </span> -->
      <!-- </template>
    </Column> -->
    <Column field="Address" :header="$t('address')">
      <template #filter="{ filterModel, filterCallback }">
        <InputText
          type="text"
          :placeholder="$t('address')"
          v-if="filterModel"
          v-model="filterModel.value"
          @keydown.enter="filterCallback()"
          class="p-column-filter p-inputtext-sm"
        />
      </template>
      <template #body="slotProps">
        <Textarea
          v-model="slotProps.data[slotProps.column.props.field]"
          class="p-inputtext-sm"
          rows="1"
          cols="50"
          @change="editDetail(slotProps.data)"
          :autoResize="true"
		  :disabled="!canEdit"
        />
      </template>
    </Column>
    <Column field="Phone" :header="$t('phone')">
      <template #filter="{ filterModel, filterCallback }">
        <InputText
          type="text"
          :placeholder="$t('phone')"
          v-if="filterModel"
          v-model="filterModel.value"
          @keydown.enter="filterCallback()"
          class="p-column-filter p-inputtext-sm"
        />
      </template>
      <template #body="slotProps">
        <InputText
          type="text"
          v-model="slotProps.data[slotProps.column.props.field]"
          class="p-inputtext-sm"
		  :disabled="!canEdit"
          @change="editDetail(slotProps.data)"
        />
      </template>
    </Column>
    <Column field="Date_Of_Birth" :header="$t('date_of_birth')">
      <template #filter="{ filterModel, filterCallback }">
      <DatePicker
          :placeholder="$t('date_of_birth')"
          format="dd/mm/yy"
          v-if="filterModel"
          v-model="filterModel.value"
          @keydown.enter="filterCallback()"
          class="p-column-filter p-inputtext-sm"
        />
      </template>
      <template #body="slotProps">
        <DatePicker
          format="dd/mm/yy"
          v-model="slotProps.data[slotProps.column.props.field]"
          class="p-inputtext-sm"
          style="min-width: 100px"
		  :disabled="!canEdit"
          @change="editDetail(slotProps.data)"
        />
      </template>
    </Column>
    <Column field="Reason" :header="$t('blacklist_reason')">
      <template #filter="{ filterModel, filterCallback }">
        <InputText
          type="text"
          :placeholder="$t('blacklist_reason')"
          v-if="filterModel"
          v-model="filterModel.value"
          @keydown.enter="filterCallback()"
          class="p-column-filter p-inputtext-sm"
        />
      </template>
      <template #body="slotProps">
        <span class="p-input-icon-left">
          <Checkbox
            name="blacklist"
            class="checkbox-input"
            :binary="true"
            v-model="slotProps.data.Blacklist"
            @change="isBlackList(slotProps.data)"
			:disabled="!canEdit"
          />
          <InputText
            type="text"
            v-model="slotProps.data[slotProps.column.props.field]"
            placeholder="Reason"
            :disabled="!slotProps.data.Blacklist && !canEdit"
            @change="editDetail(slotProps.data)"
          />
        </span>
      </template>
    </Column>
	<Column field="Is_Locked" header="Lock/Unlock">
      <template #body="slotProps">
		<Button label="Lock/Unlock" class="p-button-primary" v-if="header" :disabled="!canEdit" @click="openDialog(slotProps.data)" />
      </template>
    </Column>
    <Column field="Location" :header="$t('location')">
      <!-- <template #filter="{ filterModel, filterCallback }">
        <InputText
          type="text"
          :placeholder="$t('location')"
          v-if="filterModel"
          v-model="filterModel.value"
          @keydown.enter="filterCallback()"
          class="p-column-filter p-inputtext-sm"
        />
      </template> -->
      <template #body="slotProps">
        <CustomMultiSelect :disabled="!canEdit" v-model="slotProps.data.locations" :url="$API_URL + 'list/location_by_user'" :params="{ transporter_code: transporter_code}" @change="editDetail(slotProps.data)"/>
      </template>
    </Column>
  </DataTable>

  <ChangePassword
    v-model:isVisible="this.isVisible"
    v-model:model="modelPassword"
    :userId="this.userId"
    @block-ui="block"
    @unblock-ui="unBlock"
	:changeFirstLogin="true"
  />

  	<Dialog header="Lock/Unlock Account" v-model:visible="displayDialog" :closable="false" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}">
		<div>
			<Message severity="warn" :closable="false">
				{{ inactive_msg }} ({{ Is_Locked ? 'Locked' : 'Unlocked'}})
			</Message>
			<h6 id="single">Please select lock or unlock account</h6>
			<SelectButton v-model="Is_Locked" :options="lockOption" optionLabel="name" optionValue="value" aria-labelledby="single" />
		</div>
		<template #footer>
			<Button label="Cancel" icon="pi pi-times" @click="closeDialog" class="p-button-text"/>
			<Button label="Save" icon="pi pi-check" @click="saveLockUser" />
		</template>
	</Dialog>
  <!-- <Location
    v-model:locationVisible="this.locationVisible"
    :model="this.locationModel"
    :transporterCode="this.transporter_code"
    :url="this.url + '/save_location'"
    title="Driver Location"
    @block-ui="block"
    @unblock-ui="unBlock"
    @success="updateLocation"
  /> -->
</template>
<script>
export default {
	data() {
		return {
			url: this.$API_URL + "driver",
			dialogType: null,
			isVisible: false,
			locationVisible: false,
			locationModel: null,
			modelPassword: null,
			userId: null,
			filters: null,
			locations: [],

			driverData: null,
			Is_Locked: null,
			lockOption: [
				{name: 'Lock', value: true},
				{name: 'Unlock', value: false},
			],
			displayDialog:false,
			inactive_msg: ""
		};
	},
	props: {
		header: {
			type: Object,
			default: null,
		},
		blueprint: {
			type: Object,
			default: null,
		},
		transporter_code: {
			type: String,
			default: "",
		},
		mode:{
			type: String,
			default: null
		},
    transporterHeader:{
      type:Object,
      default:null
    }
	},
	mounted() {
		this.setFilters();
	},
	methods: {
		clearFilter() {
			this.filters = {};
			var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
			for (var i = 0; i < exportable.length; i++) {
				this.filters[exportable[i].props.field] = {
				value: null,
				matchMode: "contains",
				};
			}
		},
		setFilters() {
			this.filters = {};
			var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
			for (var i = 0; i < exportable.length; i++) {
				var filterValue = null;
				if (this.stateFilters) {
					field = this.stateFilters[exportable[i].props.field];
					if (field) filterValue = field.value;
				}
				this.filters[exportable[i].props.field] = {
					value: filterValue,
					matchMode: "contains",
				};
			}
		},
		openLocationDialog(data) {
			data.Helper_Locations = data.Driver_Locations?data.Driver_Locations:[]
			this.locationVisible = true;
			this.locationModel = data;
      		document.activeElement.blur();
		},
		updateLocation(data){
			this.locationModel.Location = data.locName
			this.locationModel.Driver_Locations = data.locList
		},
		changePass(data) {
			this.isVisible = !this.isVisible;
			this.dialogType = "password";
			this.modelPassword = data;
			this.userId = data.User_Id;
		},
		showError(message){
			this.$toast.add({severity: "error", summary: "Error", detail: message, life: 120000});
		},
		saveData() {
			
			var self = this;
			var blockSave = false;

			if(this.header == null || this.header.length == 0){
				this.showError(this.$t('alert.require_driver'));
				blockSave = true;
				return;
			}
			else{
				for(var x =0; x< this.header.length;x++){
					var driver = this.header[x];

					if(!driver.Name){
						this.showError(this.$t('alert.require_name'));
						blockSave = true;
						return;
					}

					if(!driver.License_No){
						this.showError(this.$t('alert.require_license_no'));
						blockSave = true;
						return;
					}

					if(!driver.Address){
						this.showError(this.$t('alert.require_address'));
						blockSave = true;
						return;
					}

					if(!driver.Date_Of_Birth){
						this.showError(this.$t('alert.require_date_of_birth'));
						blockSave = true;
						return;
					}
				}
			}

			if(blockSave)
				return;

			this.$emit("block-ui");

			this.$axios
				.post(this.url, { drivers: this.header, mode: this.$FORM_MODE_EDIT })
				.then((response) => {
					this.$emit("unblock-ui");
					if(response.data.success){
						self.$toast.add({
						severity: "success",
						summary: "Success",
						detail: response.data.message,
						life: 120000,
						});
						self.$emit("refresh-data");
					}
					else{
						self.$toast.add({
						severity: "error",
						summary: "Error",
						detail: response.data.message,
						life: 120000,
						});
					}
				})
				.catch((err) => {
					this.$emit("unblock-ui");
					this.$toast.add({
						severity: "error",
						summary: "Error",
						detail: err,
						life: 120000,
					});
				});
		},
		saveLockUser(){
			var self = this;
			var data = {
				"user_id": this.driverData.Id_User,
				"is_locked": this.Is_Locked
			};

			this.$emit('block-ui');
			this.$axios.post(this.$API_URL + "util/user_lock_unlock/", data)
			.then((response) => {
				self.$emit("refresh-data");
				self.$emit('unblock-ui');
				self.closeDialog();
				if (response.data.success){
					self.$toast.add({ severity: 'success', summary: 'Success Saving Data', detail: "Driver account has been saved successfully.", life: 50000});
				}
				else{
					self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: error, life: 5000});
				}
			})
			.catch(function (error) {
				self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: error, life: 5000});
				self.$emit('unblock-ui');
			});
		},
		rowClass(data) {
			return data
				? data.mode == this.$FORM_MODE_DELETE
				? "hidden"
				: ""
				: null;
		},
		addDetail() {
			var newDetail = { ...this.blueprint };
			newDetail.mode = this.$FORM_MODE_CREATE;
			newDetail.Transporter_Code = this.transporter_code;
			this.header.unshift(newDetail);

			//this.$refs.dt.goToLastPage();

		},
		editDetail(data) {
			if (data.mode == this.$FORM_MODE_UNCHANGED) {
				data.mode = this.$FORM_MODE_EDIT;
			}
		},
		deleteDetail(data) {
			if (data.mode == this.$FORM_MODE_CREATE) {
				var index = this.header.indexOf(data);
				this.header.splice(index, 1);
			} else {
				data.mode = this.$FORM_MODE_DELETE;
			}
		},
		isBlackList(data) {
			if (!data.Blacklist) {
				data.Reason = null;
			}
		},
		block() {
			this.$emit("block-ui");
		},
		unBlock() {
			this.$emit("unblock-ui");
		},
		driverLocation(slotProps){
			var data = slotProps.data;


		},
		openDialog(data){
			this.driverData = data;
			this.Is_Locked = data.Is_Blocked;
			this.inactiveMsg();
			this.displayDialog = true;
		},
		closeDialog(){
			this.displayDialog = false;
			// this.Is_Locked = this.header.Is_Locked;
		},
		inactiveMsg(){
			var userAccount = this.driverData;
			var lastAccessDate = new Date(this.$moment(userAccount.Last_Access_Date).format('L'));
			var currentDate = new Date(this.$moment(new Date()).format('L'));

			var lastDuration = currentDate.getTime() - lastAccessDate.getTime();
			var totalDays = lastDuration / (1000 * 3600 * 24);

			if(isNaN(totalDays)){
				this.inactive_msg = "This account has never been active. ";
			}
			else{
				this.inactive_msg = "This account has been inactive for "+totalDays+" days. ";
			}
		}
	},
	computed: {
		filterBadge() {
			var badgeNumber = 0;

			this.dataFilter.filter(function (item) {
				if (item.value && item.field != "Status") {
				badgeNumber++;
				}
			});

			return badgeNumber;
		},
		dataFilter() {
			var h = [];
			if (this.filters) {
				for (const [key, value] of Object.entries(this.filters)) {
				h.push({
					field: key ? key : null,
					value: value.value,
					matchMode: value.matchMode,
				});
				}
			}
			return h;
		},
		dialogTitle() {
			return this.dialogType == "password"
				? "Change Password"
				: "Change Location";
		},
		canSave(){
			return  this.mode ? this.mode != this.$FORM_MODE_VIEW : false;
		},
		canEdit(){
			return this.mode ? this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT : false;
		}
	},
	emits: ["block-ui", "unblock-ui", "refresh-data"],
};
</script>
<style>
.checkbox-input {
  position: absolute;
  margin: 7px 0 0 5px;
  z-index: 2;
}

.checkbox-input .p-checkbox-box {
  width: 16px;
  height: 16px;
}

.hidden {
  display: none;
}
/* .p-datatable-tbody{
  max-height: 200px !important;
  height: 200px !important;
  min-height: 200px !important;
  overflow-y: scroll;
} */
</style>
